import { ComponentProps } from "react";
import { formatMoney } from "../../utils/number";
import { useLicensesOverview } from "../../views/Licenses/LicensesOverview/LicensesOverview";

export const Price = ({ value }) => {
   const { hidePrices, updateHidePrices } = useLicensesOverview();

   return (
      <span>R$ {hidePrices ? '****' : `${formatMoney(value)}`}</span>
   );
}